function Api(context) {
    this.context = context;
}

Api.prototype.get = function(path, opt_params) {
    return this.context.$http.get(path, {
        params: opt_params
    });
};

Api.prototype.post = function(path, opt_params) {
    return this.context.$http.post(path, opt_params);
};

Api.prototype.put = function(path, opt_params) {
    return this.context.$http.put(path, opt_params);
};

Api.prototype.delete = function(path) {
    return this.context.$http.delete(path);
};

function Form(context, opt_model) {
    this.context = context;
    this.api = new Api(context);
    this.model = _.cloneDeep(opt_model || {});
    this.$errors = {};
    this.appMessage = null;
    this.waiting = false;
}

Form.prototype.request = function(methodName, path, opt_callback, opt_errback) {
    // avoid double clicking
    if (this.waiting) {
        return;
    }
    this.clear();
    this.waiting = true;

    var method = {
        get: Api.prototype.get,
        post: Api.prototype.post,
        put: Api.prototype.put,
        delete: Api.prototype.delete
    }[methodName.toLowerCase()];

    _.forEach(this.model, function(val, key, model) {
        if (_.isString(val)) {
            model[key] = _.trim(val);
        }
    });

    return method.call(this.api, path, this.model)
    .then(function(response) {
        this.waiting = false;
        var next = this._handle(response);
        next && opt_callback && opt_callback.call(this.context, response);
        return Promise.resolve(response);
    }.bind(this), function(err) {
        this.waiting = false;
        this._handleError(err);
        opt_errback && opt_errback.call(this.context, err);
        return Promise.reject(err);
    }.bind(this));
};

Form.prototype.get = function(path, opt_callback, opt_errback) {
    return this.request('GET', path, opt_callback, opt_errback);
};

Form.prototype.post = function(path, opt_callback, opt_errback) {
    return this.request('POST', path, opt_callback, opt_errback);
};

Form.prototype.put = function(path, opt_callback, opt_errback) {
    return this.request('PUT', path, opt_callback, opt_errback);
};

Form.prototype.delete = function(path, opt_callback, opt_errback) {
    return this.request('DELETE', path, opt_callback, opt_errback);
};

Form.prototype.download = function(path, opt_additionalParams) {
    const params = {
        ...this.model,
        ...opt_additionalParams,
    };
    const queryString = Object.keys(params).map(key => `${key}=${encodeURIComponent(params[key])}`).join('&');
    const link = document.createElement('a');
    link.href = `${path}?${queryString}`;
    document.body.appendChild(link);
    link.click();
}

Form.prototype.init = function() {
    this.model = {};
    this.clear();
};

Form.prototype.clear = function() {
    this.$errors = {};
    this._updateAppMessage('')
};

Form.prototype.hasErrors = function() {
    return !_.isEmpty(this.$errors);
};

Form.prototype.hasError = function(fieldName) {
    return !!this.$errors[fieldName];
};

Form.prototype.error = function(fieldName) {
    var err = this.$errors[fieldName];
    if (!err) {
        return null;
    }
    if (err.detail) {
        err = err.detail;
    }
    if (err.length > 0) {
        return err[0];
    }
    return err;
};

Form.prototype._handle = function(response) {
    var redirectTo = response.headers['x-location'];
    if (redirectTo) {
        window.location.href = redirectTo;
        return false;
    }
    return true;
};

Form.prototype._handleError = function(err) {
    var response = err.response;
    var status = response.status;
    if (status === 400) {
        this.$errors = response.data;
    } else if (String(status).substring(0, 1) === '5') {
        this._updateAppMessage('システムエラーが発生しました。')
        /* eslint-disable */
        console.log(response.data)
        /* eslint-enable */
    } else {
        this._updateAppMessage(response.data, status)
    }
};

Form.prototype._updateAppMessage = function(message, status) {
    this.appMessage = message.detail;
    this.appMessage && this.context.$nextTick(function() {
        if (status === 403 && _.includes(this.appMessage.toLowerCase(), 'csrf')) {
            alert('不正なアクセスを防止する機能により、処理が中断されました。');
            window.location.reload();
        } else if ($('.appMessage').length === 0) {
            alert(this.appMessage);
        }
    }.bind(this));
};

export { Form, Api };
